import {type PaletteOptions} from "@mui/material";

interface ThemedPaletteOptions extends PaletteOptions {
    primary: {
        main: string;
    };
    secondary: {
        main: string;
    };
    contrast: {
        main: string;
        light?: string;
    };
    night: {
        main: string;
    };
    greys: {
        main: string;
        light?: string;
        "300"?: string;
    };
    anGreen: {
        main: string;
        mint: string;
        emerald: string;
        heading: string;
        positive: string;
        heroStart: string;
        heroEnd: string;
    };
}

export const palette: ThemedPaletteOptions = {
    primary: {
        main: "#0acbaa"
    },
    secondary: {
        main: "#0081ce"
    },
    contrast: {
        main: "#fdcd43",
        light: "#f7d302"
    },
    night: {
        main: "#2d3033"
    },
    greys: {
        main: "#eceded",
        light: "#f9f9f9",
        "300": "rgba(236, 237, 237, 1.00)",
    },
    anGreen: {
        main: "#48BD9C",
        mint: "#48BD9C",
        emerald: "#2CA082",
        heading: "#1C453D",
        positive: "#027A48",
        heroStart: "#1C5346",
        heroEnd: "#0ACBAA",
    },
};

/* #55070: mode-aware semantic colors. MUI's defaults (and the former #ff0022 /
 * #ff00ff placeholders) neither matched the brand palette nor stayed legible
 * on the dark surfaces, so error/success mirror the CSS tokens --an-error-text
 * and --an-delta-positive from App.css (kept as literals — MUI derives
 * light/dark/contrastText from `main` and cannot resolve CSS variables).
 * MUI palette-mode switching happens in MuiThemeLocaleAdapter, CSS-token
 * flipping via [data-theme="dark"] — keep both in sync. */
export const semanticColors = (mode: "light" | "dark"): PaletteOptions => ({
    error: {main: mode === "dark" ? "#E88AA3" : "#BD4769"},
    success: {main: mode === "dark" ? "#48BD9C" : "#027A48"},
    warning: {main: mode === "dark" ? "#FDB022" : "#B54708"},
    info: {main: mode === "dark" ? "#7CC0EA" : "#0081CE"},
});
